// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5037) return "static/chunks/5037-69a75c52cce21abd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"162":"6ef701307a2cd087","8971":"e1cea3f94cbc32b2"}[chunkId] + ".js";
};